import React from 'react';

import DeviceNames from './DeviceNames';
import DeviceIcons from './DeviceIcons';
import DeviceValues from './DeviceValues';

import EditMenu from './EditMenu';

const Device = ({ device, user, timeZone }) => {
  const isLeakage = device?.type?.sub_type?.key === 'sensor:water:leakage';

  return (
    <div className={isLeakage ? 'flex items-start justify-between gap-3 sm:gap-4' : 'flex items-center justify-between gap-4'}>
      <div className={isLeakage ? 'mt-1 shrink-0' : 'shrink-0'}>
        <DeviceIcons device={device} />
      </div>

      <div className="mr-auto min-w-0 flex-1 overflow-hidden">
        <DeviceValues
          device={device}
          timeZone={timeZone}
          style="truncate text-gray-800 text-lg sm:text-xl md:text-xl lg:text-xl"
        />
        <DeviceNames device={device} style="text-sm line-clamp-1 text-gray-400" />
      </div>

      <div className={isLeakage ? 'mt-1 shrink-0' : 'shrink-0'}>
        <EditMenu device={device} user={user} timeZone={timeZone} />
      </div>
    </div>
  );
};

export default Device;
